import { render, staticRenderFns } from "./MentorDiaryForm.vue?vue&type=template&id=45b90fa8&"
import script from "./MentorDiaryForm.vue?vue&type=script&lang=js&"
export * from "./MentorDiaryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports